import { handleActions, createAction } from 'redux-actions';

export const setEnterprise = createAction('app/SET_ENTERPRISE');

export const enterprise = handleActions(
  {
    [setEnterprise]: (state, action) => ({
      ...state,
      ...action.payload,
    }),
  },
  {}
);
